import React, { useState } from 'react';
import DeliveryOptions from '../../../components/sections/owners-osb/delivery-options/light-journey/light-delivery-options';
import './delivery-options-view.scss';
import { useOSBStep } from '../../../hooks/owners-osb';
import { OsbLoader } from '../../../components/common/osb-loader/osb-loader';
import { OsbAlertMessagePopup } from '../../../components/sections/owners-osb/common/osb-alert-message-popup/osb-alert-message-popup';

export function DeliveryOptionsView() {
    const { osbStep } = useOSBStep();
    const [voucherAlertMessage, setVoucherAlertMessage] = useState<string>('');
    const [voucherAlertSuccess, setVoucherAlertSuccess] = useState<boolean>(
        false
    );

    // added this method to handle OsbAlertMessage from light vehicle section to OsbAlertMessage component
    const osbAlertMessagePopup = (message: string, success: boolean) => {
        setVoucherAlertMessage(message);
        setVoucherAlertSuccess(success);
    };

    const closeOsbAlertPopup = () => {
        setVoucherAlertMessage('');
    };
    return (
        <>
            {osbStep.isMainWrapperInitialized ? (
                <>
                    {voucherAlertMessage && (
                        <OsbAlertMessagePopup
                            alertMessage={voucherAlertMessage}
                            alertSuccess={voucherAlertSuccess}
                            closeOsbAlertPopup={closeOsbAlertPopup}
                        />
                    )}
                    <div className="delivery-step-view-container">
                        <DeliveryOptions
                            osbAlertMessagePopup={osbAlertMessagePopup}
                        />
                    </div>
                </>
            ) : (
                <OsbLoader osbEmptyContentHeight={true} />
            )}
        </>
    );
}
